import store from "../store";
import { openAuthModal, prepareAuthModal, AUTH_QUERY_KEY, AUTH_VIEW } from "../utils/authModal.js";

function merchantHomePath(to) {
  if (window.IS_MERCHANT_CODE_HIDE) return '/'
  const merchantCode = store.getters.getMerchant.code || to.params.merchant_code
  return `/${merchantCode}`
}

export default (to, from, next) => {
  if (store.getters.isLoggedIn) return next()

  const config = {
    view: AUTH_VIEW.LOGIN,
    redirect: { name: to.name, params: to.params, query: to.query }
  }

  /* in-app navigation: keep the page the user is already looking at */
  if (from.name) {
    next(false)
    Promise.resolve().then(() => openAuthModal(config))
    return
  }

  /* cold deep link has no page underneath, so land on the merchant home with the
     popup query already set — a nested push during a guard would fight this one */
  const homePath = merchantHomePath(to)
  if (!prepareAuthModal(config)) return next({ path: homePath })

  const query = {}
  query[AUTH_QUERY_KEY] = AUTH_VIEW.LOGIN
  return next({ path: homePath, query: query })
}



// WEBPACK FOOTER //
// ./src/router/UserAuth.js